<template>
  <div>
    <el-dialog
      :title="type === 'add' ? '新增标签' : '编辑标签'"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="标签名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入，不超过4字" />
        </el-form-item>
        <el-form-item>
          <span slot="label">
            <span style="color: #f66c6d; margin-right: 4px">*</span>
            标签图标
          </span>
          <uploadImage
            v-if="!isUpload && dialogVisible"
            :file="netLicensePhotoSubpage"
            :code="'custom-flight'"
            @uploadSuccess="getIcon"
            @remove="getIcon"
          />
          <div v-else class="flex flex-align-center">
            <el-image style="width: 20px; height: 20px" :src="rowData.icon" />
            <span style="cursor: pointer; color: #3d9ffc; margin-left: 20px" @click="handleChange">
              更换
            </span>
          </div>
        </el-form-item>
        <el-form-item label="主题色" prop="color">
          <el-input v-model="ruleForm.color" placeholder="请输入主题色" readonly />
          <input
            type="color"
            v-model="ruleForm.color"
            style="width: 30px; height: 30px; margin-top: 10px"
          />
        </el-form-item>
        <!-- <el-form-item label="" prop="position">
          <el-checkbox v-model="ruleForm.position">置顶显示</el-checkbox>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="info" :loading="submitLoading" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import uploadImage from '@/components/newUpload/index.vue'
  import { labelSave } from '@/api/transport/bustime'

  export default {
    components: {
      uploadImage
    },
    data() {
      return {
        dialogVisible: false,
        type: '',
        ruleForm: {
          name: '',
          icon: '',
          // position: 0,
          color: '#24C3A6'
        },
        rules: {
          name: [{ required: true, message: '请输入标签名称', trigger: 'change' }]
        },
        rowData: {},
        isUpload: false,
        submitLoading: false
      }
    },
    methods: {
      init(row, type) {
        console.log('row', row)
        this.dialogVisible = true
        this.type = type
        if (type === 'edit') {
          this.ruleForm = row
          // this.ruleForm.position = row.position === 1
          this.ruleForm.color = row.color
          this.rowData = row
          this.isUpload = true
        }
      },
      handleClose() {
        this.dialogVisible = false
        this.$refs.ruleForm.resetFields()
        this.isUpload = false
        this.ruleForm.name = ''
        this.$emit('close')
      },
      getIcon(arr) {
        if (arr.length) {
          this.ruleForm.icon = arr[0].url
        } else {
          this.ruleForm.icon = ''
        }
      },
      handleChange() {
        this.isUpload = !this.isUpload
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            if (this.type === 'add' && !this.ruleForm.icon) {
              this.$message.info('请上传标签图标')
              return
            }
            try {
              this.submitLoading = true
              const { code } = await labelSave({
                icon: this.ruleForm.icon,
                id: this.type === 'edit' ? this.rowData.id : '',
                name: this.ruleForm.name,
                // position: this.ruleForm.position ? 1 : 0,
                color: this.ruleForm.color
              })
              if (code !== 0) return
              this.$message.success('保存成功')
              this.handleClose()
            } catch (error) {
              console.log(error)
            } finally {
              this.submitLoading = false
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
